import AScene from "../../library/ExtendedObjects/AScene.js";
import gameData from "../../gameData.js";
import Navbar from "../ui/Navbar.js";
import Facemask from "../ui/Facemask.js";
import InfoBar from "../ui/InfoBar.js";
import SideUI from "../ui/SideUI.js";
import {createPrintAssets} from "../game/SavePrint"
import DragTools from "../ui/DragTools.js";

export default class Game extends AScene
{
    static get KEY() { return 'Game'; }
    create()
    {
        this.stopSounds();

        this.maskAdj = {x:130, y:385};
        
        this.background = this.addImage(this.mid.x, this.mid.y, "Bckg").setInteractive();

        this.navbar = new Navbar(this);

        this.faceMask = new Facemask(this);

        this.infoBar = new InfoBar(this);

        this.sideUI = new SideUI(this);

        this.aboveAllCont = this.add.container();
        this.aboveAllCont.setDepth(100);

        this.background.on('pointerup', () => {this.removeTools();});
    }

    addAccessory(accessory, toMask = false, toTray = false, toAbove = false)
    {
        if(toMask){
            
            this.faceMask.add(accessory);
            accessory.x -= this.faceMask.x;
            accessory.y -= this.faceMask.y;
        }
        else if(toAbove){
            this.aboveAllCont.add(accessory);
            accessory.x += this.maskAdj.x;
            accessory.y += this.maskAdj.y;

            if(accessory.isClone){
                let color = accessory.type === "letter" ? 0xef608c : 0xf98f10;

                if(!this.dragTools) {
                    this.dragTools = new DragTools(this, accessory, this.aboveAllCont, color);
                }
                else {
                    if(this.dragTools.dragger !== accessory){
                        this.removeTools();
                        this.dragTools = new DragTools(this, accessory, this.aboveAllCont, color);
                    }
                }
            }
            else{
                this.removeTools();
            }
        }
        else if(toTray){
            if(accessory.type === "letter") this.navbar.letterTray.addAt(accessory, 0);
            if(accessory.type === "patch") this.navbar.patchTray.addAt(accessory, 0);
        }
    }

    removeTools()
    {
        if(this.dragTools){
            this.dragTools.cleanUp();
            this.dragTools.destroy();
            this.dragTools = null;
        };
    }

    pauseGame()
    {
        gameData.gamePaused = true;
        this.sideUI.toggleBtns(false);
        this.navbar.toggleBtns(false);

        gameData.accessories.forEach(btn => {
            btn.disableInteractive();
            if(this.input._draggable.includes(btn)) this.input.setDraggable(btn, false);
        });
    }

    resumeGame()
    {
        gameData.gamePaused = false;
        this.sideUI.toggleBtns(true);
        this.navbar.toggleBtns(true);

        gameData.accessories.forEach(btn => {
            btn.setInteractive();
            this.input.setDraggable(btn);
        });
    }

    resetGame()
    {
        this.aboveAllCont.list.forEach(accessory => {accessory.destroy();});
        gameData.accessories.forEach(accessory => {accessory.destroy();});
        gameData.accessories = [];

        this.faceMask.setFace();
        this.faceMask.setPattern();
        this.faceMask.clearPaint();
        this.faceMask.tintMask("0xf2f0e7", "all");

        this.navbar.clearActiveTrays();
        this.navbar.tweenOutBtn(null, false);
    }

    toggleSavePrint(toPrint, isPrint)
    {
        if(toPrint)
        {
            this.pauseGame();

            this.faceMask.tweenInMask();
            this.infoBar.tweenOutBar();
            this.navbar.tweenOutNavbar();
            this.sideUI.tweenOutUI();
            createPrintAssets(this, isPrint, this.toggleSavePrint.bind(this));

            gameData.previousGameMode = gameData.gameMode;
            gameData.gameMode = 7; // turns off game modes so that paint doesn't occur anymore
        }
        else
        {
            this.resumeGame();

            this.faceMask.tweenOutMask();
            this.infoBar.tweenInBar();
            this.navbar.tweenInNavbar();
            this.sideUI.tweenInUI();
        }
    }

    cleanUp(toScene)
    {
        gameData.accessories = [];
        gameData.bgColor = "0xf2f0e7";
        gameData.trimColor = "0x4c4b48";
        gameData.paintColor = "0xf2f0e7";
        gameData.brushSize = 1;
        gameData.isErasing = false;
        gameData.faceActive = false;
        gameData.patternActive = false;

        this.background.destroy();
        this.aboveAllCont?.destroy();

        this.navbar.cleanUp();
        this.navbar.destroy();

        this.faceMask.cleanUp();
        this.faceMask.destroy();

        this.infoBar.cleanUp();
        this.infoBar.destroy();

        if(toScene) this.scene.start(toScene);
    }
}